<template>
    <div>
        <filters :scope="filtersScope">
        </filters>
        <ConversionsTabs></ConversionsTabs>
        <StatisticTable
                        class="animated fadeIn"
                        :footColumns="footColumns"
                        :headColumns="headColumns"
                        :rows="rows"
                        :title="`${$t('pages.conversions')}`">
        </StatisticTable>
    </div>
</template>

<script>
import Filters from '../../../components/Filters.vue'
import ConversionsTabs from './ConversionsTabs.vue'
import Helper from '../../../api/Helper'
import TypeColor from '../../../assets/TypeColor'
import API from '../../../api/API'
import Storage from '../../../api/Storage'
import { map, join } from 'lodash'
import StatisticTable from '../../../components/StatisticTable.vue'
import getSymbolFromCurrency from 'currency-symbol-map'

export default {
  name: 'Buyout',
  components: {
    Filters,
    ConversionsTabs,
    StatisticTable
  },
  data () {
    return {
      scrollPos: 0,
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byManualFilter: true
      },
      isLoading: false,
      Storage: Storage,
      TypeColor: TypeColor,
      Helper: Helper,
      headColumns: [
        {label: this.$root.$t('statistic.sets'), field: 'date', width: '200px'},
        {label: this.$root.$t('statistic.cross_sell_cost'), field: 'cross_sell_cost', colspan: 2},
        {label: this.$root.$t('statistic.orders_accepted'), field: 'orders_accepted'},
        {label: this.$root.$t('statistic.proportion'), field: 'proportion'},
        {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2},
        {label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2},
        {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
        {label: this.$root.$t('statistic.buyout'), field: 'buyout', colspan: 2}
      ],
      rows: [],
      data: [],
      footColumns: {},
      offers: [],
      alphabet: []
    }
  },
  mounted () {
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  methods: {
    async calculateRows () {
      this.$root.$emit('data_loading')
      this.rows = []
      this.footColumns = {}
      let findGoodsItem = []
      await API.getGoodsMain().then(response => {
        findGoodsItem = response.body
      })
      await API.getConversionsBuyoutStatistic().then(response => {
        let sumTotalBillCross = 0.0
        let sumTotalLocalCross = 0.0
        let sumTotalBill = 0.0
        let sumTotalBillLocal = 0.0
        let sumTotalBuyout = 0.0
        let sumTotalBuyoutLocal = 0.0
        let sumApproved = 0
        let sumTotalRefunded = 0
        let sumTotalPaid = 0
        let oldArrCurrency = []
        let newArrCurrency = []
        const resultAverage = (billCost, approvedCost) => {
          return billCost > 0 ? '$ ' + (billCost / approvedCost).toFixed(2) : '$ 0.00'
        }
        const resultAverageLocal = (localCost, localApproved, currency, currencyItem) => {
          return localCost > 0 && currency === 1 ? `${(localCost / localApproved).toFixed(0)} ${getSymbolFromCurrency(currencyItem)}` : '-'
        }
        map(response.data, d => {
          oldArrCurrency.push(d.local_currency.split(','))
          oldArrCurrency.forEach(array => {
            array.forEach(item => {
              newArrCurrency.push(item)
            })
          })
        })
        let filterCurrency = newArrCurrency.filter((item, index) => {
          return newArrCurrency.indexOf(item) === index
        })
        let approvedSum = 0
        map(response.data, (d) => {
          approvedSum += d.approved
        })
        map(response.data, (d) => {
          let resultStr = d.combination.map(x => { return `${x.quantity} ${Helper.getGoodNameById(findGoodsItem, x.good_id)}` })
          this.rows.push({
            goods: {
              value: resultStr.join(' + ')
            },
            cross_sell_cost: {
              value: resultAverage(d.total_bill_cross_usd, d.approved),
              bg: true
            },
            cross_sell_local: {
              value: resultAverageLocal(d.total_bill_cross_local, d.approved, d.local_currency.split(',').length, d.local_currency)
            },
            orders_accepted: {
              value: d.approved,
              bg: true
            },
            proportion: {
              value: Helper.percents(approvedSum, d.approved)
            },
            averageBill: {
              value: resultAverage(d.total_bill_usd, d.approved)
            },
            averageBillLocal: {
              value: resultAverageLocal(d.total_bill_local, d.approved, d.local_currency.split(',').length, d.local_currency)
            },
            averageBuyback: {
              value: resultAverage(d.total_buyout_usd, d.paid)
            },
            averageBuybackLocal: {
              value: resultAverageLocal(d.total_buyout_local, d.paid, d.local_currency.split(',').length, d.local_currency)
            },
            return: {
              value: d.refunded,
              bgg: Helper.renderGistPart(d.approved, d.refunded),
              isCollspaned: true
            },
            returnPercent: {
              value: Helper.percents(d.approved, d.refunded),
              bgg: Helper.renderGistPart(d.approved, d.refunded, true)
            },
            buyout: {
              value: d.paid,
              bgg: Helper.renderGistPart(d.approved, d.paid),
              isCollspaned: true
            },
            buyoutPercent: {
              value: Helper.percents(d.approved, d.paid),
              bgg: Helper.renderGistPart(d.approved, d.paid, true)
            }
          })
          sumApproved += d.approved
          if (d.total_bill_cross_usd > 0) {
            sumTotalBillCross += d.total_bill_cross_usd
          }
          if (d.total_bill_cross_local > 0) {
            sumTotalLocalCross += d.total_bill_cross_local
          }
          if (d.total_bill_usd > 0) {
            sumTotalBill += d.total_bill_usd
          }
          if (d.total_bill_local > 0) {
            sumTotalBillLocal += d.total_bill_local
          }
          if (d.total_buyout_usd > 0) {
            sumTotalBuyout += d.total_buyout_usd
          }
          if (d.total_buyout_local > 0) {
            sumTotalBuyoutLocal += d.total_buyout_local
          }
          if (d.refunded > 0) {
            sumTotalRefunded += d.refunded
          }
          if (d.paid > 0) {
            sumTotalPaid += d.paid
          }
          this.localCurrencySymbol = getSymbolFromCurrency(d.local_currency)
        })
        this.footColumns = {
          label: {
            value: this.$root.$t('statistic.in_total')
          },
          cross_sell_cost: {
            value: resultAverage(sumTotalBillCross, sumApproved)
          },
          cross_sell_local: {
            value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumTotalLocalCross, sumApproved, this.localCurrencySymbol) : '-'
          },
          orders_accepted: {
            value: `${sumApproved}`
          },
          proportion: {
            value: null
          },
          averageBill: {
            value: resultAverage(sumTotalBill, sumApproved)
          },
          averageBillLocal: {
            value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumTotalBillLocal, sumApproved, this.localCurrencySymbol) : '-'
          },
          averageBuyback: {
            value: resultAverage(sumTotalBuyout, sumTotalPaid)
          },
          averageBuybackLocal: {
            value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumTotalBuyoutLocal, sumTotalPaid, this.localCurrencySymbol) : '-'
          },
          return: {
            value: sumTotalRefunded
          },
          returnPercents: {
            value: Helper.percents(sumApproved, sumTotalRefunded)
          },
          paid: {
            value: sumTotalPaid
          },
          paidPercents: {
            value: Helper.percents(sumApproved, sumTotalPaid)
          }
        }
        this.$root.$emit('data_loaded')
      }).catch(response => {
        this.$root.$emit('data_loaded')
        this.$notify({
          type: 'danger',
          title: this.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        })
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Buyout.vue?1a5e2dec